
export default function useGetDomain(){
    if(process.env.NEXT_PUBLIC_ENVIRONMENT !== "local"){
        return window.location.hostname
    }
    return process.env.NEXT_PUBLIC_TEST_DOMAIN;
}